import { DateField, DateTimeField, TextField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	name: string;
}

const MultiValueWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: ${({ theme }) => theme.spacing(1)};
`;

export const BetweenDateTimeValueField: FC<Props> = ({ name }) => {
	const { t } = useTranslation();

	return (
		<MultiValueWrapper>
			<DateTimeField label={t("Start")} name={`${name}.start`} />
			<DateTimeField label={t("End")} name={`${name}.end`} />
		</MultiValueWrapper>
	);
};

export const BetweenDateValueField: FC<Props> = ({ name }) => {
	const { t } = useTranslation();

	return (
		<MultiValueWrapper>
			<DateField label={t("Start")} name={`${name}.start`} />
			<DateField label={t("End")} name={`${name}.end`} />
		</MultiValueWrapper>
	);
};

export const BetweenNumberValueField: FC<Props> = ({ name }) => {
	const { t } = useTranslation();

	return (
		<MultiValueWrapper>
			<TextField label={t("Start")} name={`${name}.start`} type="number" />
			<TextField label={t("End")} name={`${name}.end`} type="number" />
		</MultiValueWrapper>
	);
};
